var $c963661d89486e72$exports = {};
$c963661d89486e72$exports = {
  "ascending": "aufsteigend",
  "ascendingSort": function ascendingSort(args) {
    return "sortiert nach Spalte ".concat(args.columnName, " in aufsteigender Reihenfolge");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " Pixel");
  },
  "descending": "absteigend",
  "descendingSort": function descendingSort(args) {
    return "sortiert nach Spalte ".concat(args.columnName, " in absteigender Reihenfolge");
  },
  "resizerDescription": "Eingabetaste zum Starten der Gr\xF6\xDFen\xE4nderung dr\xFCcken",
  "select": "Ausw\xE4hlen",
  "selectAll": "Alles ausw\xE4hlen",
  "sortable": "sortierbare Spalte"
};
export { $c963661d89486e72$exports as default };